<template>
  <div class="empty-container">
    <div class="empty-item">
      <KyIcon :type="iconImg" />
      <label>{{ text }}</label>
    </div>
  </div>
</template>

<script>
import KyIcon from "@/components/KyIcon";
export default {
  props: {
    text: {
      type: String,
      default: "无数据",
    },
  },
  data() {
    return {
      iconImg: "empty",
    };
  },
  components: {
    KyIcon,
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/mixin.less";
.empty-container {
  .self-flex();
  justify-content: center;
  width: 100%;
  margin: auto;
  align-items: center;
  height: 100%;
  .empty-item {
    text-align: center;
    color: @gray;
    .icon-container {
      display: block;
      font-size: 60px;
    }
    label {
      display: block;
      margin: 1em;
      font-size: 16px;
    }
  }
}
</style>